import { allSubjects } from "./subjects";

export function performSearch(query, limit = 10) {
  if (!query) return [];

  const lowerQuery = query.toLowerCase();
  const results = [];

  Object.values(allSubjects).forEach((subjectArray) => {
    subjectArray.forEach((subject) => {
      const label = subject.label.toLowerCase();

      if (label.includes(lowerQuery)) {
        results.push(subject);
      }
    });
  });

  results.sort((a, b) => {
    return (
      a.label.localeCompare(query, undefined, { sensitivity: "base" }) -
      b.label.localeCompare(query, undefined, { sensitivity: "base" })
    );
  });

  return results.slice(0, limit);
}

